import Review from '@app/model/review/Review';
import ReviewHandlingSession from '@app/model/review/ReviewHandlingSession';
import ReviewStateState from '@app/model/review/ReviewStateState';
import { ReviewText } from '@app/model/review/ReviewText';
import ReviewTextType from '@app/model/review/ReviewTextType';
import _isEmpty from 'lodash/isEmpty';

class ReviewOutput {
	hotelName: string;
	review: Review;
	session: ReviewHandlingSession;

	constructor(data: Partial<ReviewOutput> = {}) {
		Object.assign(this, {
			...data,
			review: data.review ? new Review(data.review) : new Review(),
			session: data.session ? new ReviewHandlingSession(data.session) : new ReviewHandlingSession()
		});
	}

	public hasText(text: string) {
		return this.review.texts.some(t => t.text.toLowerCase().includes(text.toLowerCase()) || t.translation.toLowerCase().includes(text.toLowerCase()));
	}

	public isReplied() {
		return !!this.session && this.session.state === ReviewStateState.ANSWERED;
	}

	public isAssignedTo(departmentId: number) {
		return !!this.session && this.session.assignedDepartmentId === departmentId;
	}

	public getTitle() {
		return this.review.getTitle();
	}

	public getTranslatedTitle() {
		return this.review.getTranslatedTitle();
	}

	public hasContent() {
		return !_isEmpty((this.review.texts || []).filter(t=>t.type !== ReviewTextType.TITLE))
	}

	public getContent(): ReviewText[] {

		const content = (this.review.texts || []).filter(t=>t.type !== ReviewTextType.TITLE);

		if (!content) {
			return [];
		}

		return this.sortTexts(content);

	}

	public hasSessionEntries() {
		return !!this.session && !_isEmpty(this.session.logEntries);
	}

	public hasSessionEntryViewedByUserId(principalId: number) {
		return this.hasSessionEntries() && this.session.hasEntryViewedByUserId(principalId);
	}

	private sortTexts(texts: ReviewText[]) {
		// Define text type priority based on ReviewTextType enum order
		const textTypePriority = {
			[ReviewTextType.POSITIVE]: 0,
			[ReviewTextType.NEGATIVE]: 1,
			[ReviewTextType.GENERAL]: 2,
			[ReviewTextType.TITLE]: 3,
		};

		return [...texts].sort((a, b) => {
			const priorityA = textTypePriority[a.type] ?? 999; // Unknown types go to end
			const priorityB = textTypePriority[b.type] ?? 999;

			return priorityA - priorityB;
		});
	}


}

export default ReviewOutput;